/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function canCancelAppointment(appointment) {
  return !['cancelled', 'no_show', 'completed'].includes(appointment.status)
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function canMarkAppointmentNoShow(appointment) {
  return ['scheduled', 'confirmed'].includes(appointment.status)
}

/**
 * @param {string | null | undefined} code
 * @param {Array<{ value: string, label: string }>} options
 */
export function cancellationReasonLabel(code, options = []) {
  if (!code) {
    return '—'
  }

  const match = options.find((option) => option.value === code)
  return match?.label ?? code.replaceAll('_', ' ')
}
